module.exports = require('../../full/object/get-own-property-descriptors');
